import { gql } from "@apollo/client";

/**
 * Every field one dated row of the Timeline shows.
 *
 * Shared by the review page's own query and by the setup form's parameter query,
 * so the two surfaces cannot drift into showing different things about the same
 * plan. Add a field here, not in one of the two queries.
 */
export default gql`
  fragment TimelineEntry on TimelineEntryNode {
    date
    kind
    label
    note
    step
    notificationType
    channels
    recipientCount
    skippedCount
    recipientsKnown
    waitsOnAction
    triggerLabel
    sendOrder
    recipientRule
    isPast
    skipped {
      reason
      user {
        id
        name
        avatar
      }
    }
  }
`;
